// src/components/AddOrEditTaskPage/TimePicker.js

import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { handleFieldChange } from 'actions/tasks'
import TimePicker from 'components/theme/TimePicker'
// import language from 'utils/vast-languagepack'

export default connect(
	(state) => {
		const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
		const stats = task?.sms_stats || task?.email_stats
		const campaignStatus =
			state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
		const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
		const disabled = Boolean(
			(stats && automationTypeSelected !== 'stage') ||
				campaignStatus === 'L' ||
				campaignStatus === 'C',
		)

		return {
			value: state.tasks.addOrEdit.fields.time.value,
			error: state.tasks.addOrEdit.fields.time?.error || null,
			search: state.router.location.search,
			disabled,
		}
	},
	(dispatch) =>
		bindActionCreators(
			{
				handleChange: handleFieldChange,
			},
			dispatch,
		),
)((props) =>
	props.disabled ? null : (
		<TimePicker
			// noMin={props.disabled}
			{...props}
			noMin
			title="Time of day"
			helperText="If provided, this will execute your task at a time of day after the initial delay."
		/>
	),
)
